import React, { Component } from 'react';
import styled from 'styled-components';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4maps from '@amcharts/amcharts4/maps';
import am4geodata_usaLow from '@amcharts/amcharts4-geodata/usaLow';

import { COLOR_FONT_1 } from '../../colors';

/**
 *
 */
const StyledUSHeatMap = styled.div`
  height: 296px;

  @media all and (min-width: 1366px) {
    height: 512px;
  }
`;

/* eslint-disable max-lines-per-function */
/* eslint-disable max-statements */
export class USHeatMap extends Component {
  /**
   *
   */
  componentDidMount() {
    const { chartId, data } = this.props;

    am4core.options.queue = true;
    am4core.options.onlyShowOnViewport = true;

    const chart = am4core.create(chartId, am4maps.MapChart);

    chart.geodata = am4geodata_usaLow;
    chart.projection = new am4maps.projections.AlbersUsa();
    chart.mouseWheelBehavior = 'none';
    chart.seriesContainer.draggable = false;
    chart.seriesContainer.resizable = false;
    chart.maxZoomLevel = 1;
    chart.zoomable = false;

    // -- polygon series
    const polygonSeries = chart.series.push(new am4maps.MapPolygonSeries());
    polygonSeries.heatRules.push({
      property: 'fill',
      target: polygonSeries.mapPolygons.template,
      min: am4core.color('#ffc4ff'),
      max: am4core.color('#6a0080')
    });
    polygonSeries.useGeodata = true;
    polygonSeries.data = data.map((item) => ({
      id: `US-${item.name_code}`,
      url: `/states/${item.name}`,
      value: item.count,
      rank: item.rank
    }));

    // -- circle labels
    const imageSeries = chart.series.push(new am4maps.MapImageSeries());
    imageSeries.dataFields.value = 'rank';

    const imageTemplate = imageSeries.mapImages.template;
    imageTemplate.verticalCenter = 'middle';
    imageTemplate.horizontalCenter = 'middle';
    imageTemplate.propertyFields.latitude = 'lat';
    imageTemplate.propertyFields.longitude = 'long';
    imageTemplate.tooltipText = 'Rank {rank}';

    const imageCircle = imageTemplate.createChild(am4core.Circle);
    imageCircle.radius = 10;
    imageCircle.fillOpacity = 0.7;
    imageCircle.verticalCenter = 'middle';
    imageCircle.horizontalCenter = 'middle';
    imageCircle.nonScaling = true;

    const imageLabel = imageTemplate.createChild(am4core.Label);
    imageLabel.text = '{rank}';
    imageLabel.fill = am4core.color(COLOR_FONT_1);
    imageLabel.verticalCenter = 'middle';
    imageLabel.horizontalCenter = 'middle';
    imageLabel.nonScaling = true;

    imageSeries.heatRules.push({
      target: imageCircle,
      property: 'radius',
      min: 10,
      max: 30
    });

    // -- heat legend
    const heatLegend = chart.createChild(am4maps.HeatLegend);
    heatLegend.series = polygonSeries;
    heatLegend.align = 'right';
    heatLegend.valign = 'bottom';
    heatLegend.width = am4core.percent(20);
    heatLegend.marginRight = am4core.percent(4);
    heatLegend.minValue = 0;
    heatLegend.maxValue = 40000000;

    // custom heat map legend labels using axis ranges
    const minRange = heatLegend.valueAxis.axisRanges.create();
    minRange.value = heatLegend.minValue;
    minRange.label.text = 'Fewer Jobs';
    minRange.label.fill = am4core.color(COLOR_FONT_1);

    const maxRange = heatLegend.valueAxis.axisRanges.create();
    maxRange.value = heatLegend.maxValue;
    maxRange.label.text = 'More Jobs';
    maxRange.label.fill = am4core.color(COLOR_FONT_1);

    // blank out internal heat legend value axis labels
    heatLegend.valueAxis.renderer.labels.template.adapter.add('text', () => '');

    // configure series tooltip
    const polygonTemplate = polygonSeries.mapPolygons.template;
    polygonTemplate.tooltipText = '{name}: {value} Listings, Rank {rank}';
    polygonTemplate.nonScalingStroke = true;
    polygonTemplate.strokeWidth = 0.5;
    polygonTemplate.propertyFields.url = 'url';

    // create hover state and set alternative fill color
    const hs = polygonTemplate.states.create('hover');
    hs.properties.fill = am4core.color('#9c27b0');

    this.chart = chart;
  }

  /**
   *
   */
  componentWillUnmount() {
    if (this.chart) {
      this.chart.dispose();
    }
  }

  /**
   *
   */
  render() {
    return <StyledUSHeatMap id={this.props.chartId} />;
  }
}
